import { isValid, parseISO } from "date-fns";
import { StrictTypedTypePolicies } from "../../gql/__generated__/graphql";

const DateField = (date: any) => {
  if (!date) return null;
  if (isValid(date)) return date;
  return parseISO(date);
};

export const typePolicies: StrictTypedTypePolicies = {
  Query: {
    fields: {
      appSessions: {
        keyArgs: false,

        // eslint-disable-next-line @typescript-eslint/default-param-last
        merge(existing = { edges: [] }, incoming) {
          return { ...incoming, edges: [...existing.edges, ...incoming.edges] };
        }
      }
    }
  },
  Organization: {
    fields: {
      createdAt: DateField,
      members: {
        merge(_, incoming) {
          return incoming;
        }
      },
      apps: {
        merge(_, incoming) {
          return incoming;
        }
      },
      appSessions: {
        keyArgs: false,
        // eslint-disable-next-line @typescript-eslint/default-param-last
        merge(existing = { edges: [] }, incoming) {
          return {
            ...incoming,
            edges: [...existing.edges, ...incoming.edges]
          };
        }
      }
    }
  },
  AppSubscription: {
    fields: {
      createdAt: DateField,
      expiresAt: DateField,
      apiKeys: {
        merge(_, incoming) {
          return incoming;
        }
      }
    }
  },
  AppSession: {
    fields: {
      startTime: DateField,
      endTime: DateField
    }
  },
  AppDeployment: {
    fields: {
      apiKeys: {
        merge(_, incoming) {
          return incoming;
        }
      }
    }
  },
  GithubRepositoryRelease: {
    fields: {
      publishedAt: DateField
    }
  },
  StandingOffer: {
    fields: {
      createdAt: DateField
    }
  },
  UserPreferences: {
    merge: true
  },
  OrganizationInvitation: {
    fields: {
      invitedAt: DateField
    }
  }
};
